<template>
  <div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full pt-2">
          <div class="vx-col w-full mb-5 ml-6">
            <ul class="heading-ul">
              <li>
                <router-link to="/setup/charge-code" class="vx-row">
                  <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                  <h4>{{ $t("setup.label.ChargeCode") }}</h4>
                </router-link>
              </li>
            </ul>
          </div>
          <ul class="horizontal-sm-btn flex float-right">
            <li>
              <div
                class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
              >
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-edit-2"
                  class="truncate"
                  @click="editData(id)"
                  size="small"
                  >{{ $t("setup.label.Edit") }}</vs-button
                >
              </div>
            </li>
          </ul>
          <div class="table-heading pt-2" style="margin-bottom: 0px">
            {{ ChargeData.chargeCode }}
          </div>
        </div>
        <div class="vx-col w-full">
          <div class="details-layout-2 p-2">
            <vs-table stripe :data="ChargeData" class="details-table">
              <template slot="header">
                <div class="details-header w-full">
                  <div>{{ $t("setup.label.ChargeCodeData") }}</div>
                </div>
              </template>
              <template>
                <!-- </vs-thead> -->
                <vs-tr>
                  <vs-td class="light"
                    >{{ $t("setup.label.ChargeCode") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.chargeCode }}</vs-td>
                  <vs-td class="light"
                    >{{ $t("setup.label.DurationType") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.durationType }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light"
                    >{{ $t("setup.label.ChargeDescription") }} :</vs-td
                  >

                  <vs-td class="black">{{
                    ChargeData.chargeDescription
                  }}</vs-td>
                  <vs-td class="light"
                    >{{ $t("setup.label.TaxInclusive") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.taxInclusive }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light"
                    >{{ $t("setup.label.ChargeType") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.chargeType }}</vs-td>
                  <vs-td class="light"
                    >{{ $t("setup.label.BillFrequencyCode") }} :</vs-td
                  >

                  <vs-td class="black">{{
                    ChargeData.billFrequencyCode
                  }}</vs-td>
                </vs-tr>
                <vs-tr>
                  <vs-td class="light"
                    >{{ $t("setup.label.ChargeDuration") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.chargeDuration }}</vs-td>
                  <vs-td class="light"
                    >{{ $t("setup.label.IsAggregate") }} :</vs-td
                  >

                  <vs-td class="black">{{ ChargeData.isAggregate }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
        <div class="vx-col w-full mt-4">
          <div class="table-heading">{{ $t("setup.label.TaxMapping") }}</div>
          <div class="details-layout-2 p-2">
            <vs-table :data="taxMappingList.taxMapDatas">
              <template slot="thead">
                <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>
                <vs-th>{{ $t("setup.label.StartDate") }}</vs-th>
                <vs-th>{{ $t("setup.label.TaxCode") }}</vs-th>
                <vs-th>{{ $t("setup.label.TaxRegion") }}</vs-th>
                <vs-th>{{ $t("setup.label.Type") }}</vs-th>
                <vs-th>{{ $t("setup.label.Rate") }}</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="index" :data="tax" v-for="(tax, index) in data">
                  <vs-td :data="tax.chargeCode">{{ tax.chargeCode }}</vs-td>
                  <vs-td :data="tax.chargeCode">{{
                    convertDate(tax.startDate || [])
                  }}</vs-td>
                  <vs-td :data="tax.taxCode">{{ tax.taxCode }}</vs-td>
                  <vs-td :data="tax.taxRegion">{{ tax.taxRegion }}</vs-td>
                  <vs-td :data="tax.taxType">{{ tax.taxType }}</vs-td>
                  <vs-td :data="tax.rate">{{ tax.rate }}</vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      id: 0,
    };
  },
  components: {},
  computed: {
    ChargeData() {
      return this.$store.getters["chargecode/getChargeCode"];
    },
    taxMappingList() {
      return this.$store.getters["chargecode/getTaxTemplate"];
    },
  },
  methods: {
    editData(id) {
      this.$router.push({ name: "Edit Charge Code", params: { id } });
    },
    convertDate(date) {
      if (!date.length) return "";
      let dat = date[0] + "/" + date[1] + "/" + date[2];
      return moment(dat).format("DD MMMM YYYY");
    },
    async getChargeCodeById() {
      try {
        this.$store.dispatch("chargecode/setChargeCodeData", this.id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async callTaxMapping(chargeCode) {
      try {
        this.$store.dispatch("chargecode/setTaxTemplate", chargeCode);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.chargeCode = this.$route.params.chargeCode;
    await this.getChargeCodeById();
    await this.callTaxMapping(this.chargeCode);
  },
};
</script>
